var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center text-center"},[_c('div',{staticClass:"space-y-14"},[_c('h3',[_vm._v(_vm._s(_vm.$t('health_actions.attestation.success.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('health_actions.attestation.success.line_1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('health_actions.attestation.success.line_2')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }